import { makeStyles } from '@material-ui/core';

export const useReceiveBtcDialogStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: '#ababab',
    fontSize: '14px',
    lineHeight: '22px',
    margin: '0 0 32px',
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    borderRadius: '8px',
    border: '1px solid #E7E7E9',
    background: '#FFFFFF',
  },
  qrcode: {
    display: 'grid',
    justifyItems: 'center',
    gap: '24px',
  },
  copyCode: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    background: '#34353b',
    cursor: 'pointer',
    '& > p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#FAFAFA',
      [theme.breakpoints.down('xs')]: {
        width: '250px',
      },
      [theme.breakpoints.down(330)]: {
        width: '170px',
      },
    },
  },
}));
